import http from '@root/utils/axios/admin';

let state = {
    BlogsList: [],
    Blog: {
        data: {},
        error: {}
    }
}

let actions = {

    fetchBlogsList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/blogs', { params: filter }).then((response) => {
                commit('setBlogsList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },


    fetchBlog({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/blogs/' + id).then((response) => {
                commit('setBlog', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

}


let mutations = {
    setBlogsList(state, data) {
        state.BlogsList = data;
    },
    setBlog(state, data) {
        state.Blog.data = data;
    },
    setBlogLike(state, id) {
        state.Blog.data.is_liked = true;
        state.Blog.data.likes_count = state.Blog.data.likes_count + 1;
    },
    setBlogUnLike(state, id) {
        state.Blog.data.is_liked = false;
        state.Blog.data.likes_count = state.Blog.data.likes_count - 1;
    },


    setBlogsLike(state, id) {
        state.BlogsList.data.forEach(item => {
            if (item.id === id) {
                item.is_liked = true;
                item.likes_count = item.likes_count + 1;
            }
        });
    },
    setBlogsUnLike(state, id) {
        state.BlogsList.data.forEach(item => {
            if (item.id === id) {
                item.is_liked = false;
                item.likes_count = item.likes_count - 1;
            }
        });
    },
}

export default {
    state,
    actions,
    mutations
}